import { FC } from 'react';
import { CanvasTabStrip } from './CanvasTabStrip';
import { CanvasToolbar } from './CanvasToolbar';
import styles from './CanvasChrome.module.scss';

type CanvasChromeProps = {
  hidden: boolean;
};

export const CanvasChrome: FC<CanvasChromeProps> = ({ hidden }) => {
  return (
    <div
      className={styles.chrome}
      hidden={hidden}
    >
      <CanvasTabStrip />
      <CanvasToolbar />
    </div>
  );
};
